const impersonateStudent = (studentId, brandUrl) => {
    _impersonate(studentId, brandUrl, 'student');
};

const impersonateTeacher = (teacherId, brandUrl) => {
    _impersonate(teacherId, brandUrl, 'teacher');
};

const _impersonate = (userId, brandUrl, userType) => {

    const sessionId = document.getElementById('sessionId');

    if (!sessionId || sessionId.length === 0) {
        return;
    }

    const key = `${userType}_id`;

    _postForm(`//${brandUrl}/impersonate/${userType}`, {
        [key]: userId,
        session_id: sessionId.value
    });
};

const _postForm = (path, params) => {

    const form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', path);
    form.setAttribute('target', '_blank');

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            let hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', params[key]);

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}

export { impersonateStudent as student, impersonateTeacher as teacher };
